import { baseApi } from '../baseApi';
import { ListParams } from './academicYearApi';

export interface Chapter {
  id: string;
  name: string;
  number: number;
  description?: string | null;
  price: number;
  isActive: boolean;
  subjectId: string;
  academicYearId: string;
  classId: string;
  createdAt: string;
  updatedAt: string;
  subject?: { name: string };
  academicYear?: { name: string };
}

export const chapterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChapters: builder.query<{ success: boolean; data: Chapter[]; total: number; page: number; limit: number }, ListParams | void>({
      query: (params) => ({
        url: '/api/chapters',
        params: params || undefined,
      }),
      providesTags: ['Chapter'],
    }),
    createChapter: builder.mutation<{ success: boolean; data: Chapter }, Partial<Chapter>>({
      query: (body) => ({
        url: '/api/chapters',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Chapter', 'Dashboard'],
    }),
    updateChapter: builder.mutation<{ success: boolean; data: Chapter }, { id: string; body: Partial<Chapter> }>({
      query: ({ id, body }) => ({
        url: `/api/chapters/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Chapter', 'Dashboard'],
    }),
    deleteChapter: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/chapters/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Chapter', 'Dashboard'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetChaptersQuery,
  useCreateChapterMutation,
  useUpdateChapterMutation,
  useDeleteChapterMutation,
} = chapterApi;
